import { useEffect, useRef } from "react";
import { Page } from "react-pdf";

import { usePdfPageWindow } from "../../Utils/usePdfPageWindow";
import "./PdfThumbnail.css";

const THUMBNAIL_SCALE = 0.15;
// US Letter at scale 1, used until the real page size is known.
// const FALLBACK_PAGE_SIZE = { width: 612, height: 792 };

// const thumbnailSize = (pageSizes, baselineSize, pageNumber) => {
//   const size = pageSizes?.[pageNumber] || baselineSize || FALLBACK_PAGE_SIZE;
//   return {
//     width: size.width * THUMBNAIL_SCALE,
//     height: size.height * THUMBNAIL_SCALE,
//   };
// };

/**
 * The rail shell: the scrolling container plus an empty element that
 * PdfThumbnailPages is portaled into.
 *
 * The rail no longer opens the PDF itself. Splitting the shell from the pages
 * lets the thumbnails render as children of the viewer's <Document> — sharing
 * its single load — while still sitting here in the DOM.
 */
export const PdfThumbnailRail = ({ scrollRef, portalRef }) => (
  <div
    className="pdf-thumbnail"
    style={{
      paddingLeft: "10px",
      paddingRight: "10px",
      width: "120px",
      backgroundColor: "var(--primary-10)",
      scrollbarWidth: "none",
      minWidth: "120px",
    }}
    ref={scrollRef}
  >
    <div className="pdf-thumbnail-pages" ref={portalRef} />
  </div>
);

export const PdfThumbnailPages = ({
  numPages,
  pageNumbers,
  currentPage,
  scrollRootEl,
  // pageSizes,
  // baselineSize,
  onThumbnailClick,
  setPageNumber,
}) => {
  const thumbnailRef = useRef(null);
  const displayedPageNumbers =
    pageNumbers || Array.from({ length: numPages || 0 }, (_, i) => i + 1);
  const pageNumbersKey = displayedPageNumbers.join(",");
  const visiblePages = usePdfPageWindow(scrollRootEl, displayedPageNumbers.length, {
    selector: ".thumbnail-page",
    rootMargin: "100% 0px",
    initialKeys: displayedPageNumbers.length ? [displayedPageNumbers[0]] : [],
    observationKey: pageNumbersKey,
  });

  // Effect to scroll to the selected thumbnail
  useEffect(() => {
    if (thumbnailRef.current) {
      thumbnailRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [currentPage]);

  return (
    <>
      {displayedPageNumbers.map((pageNumber) => {
        // const { width, height } = thumbnailSize(pageSizes, baselineSize, pageNumber);

        return (
          <div
            key={pageNumber}
            id={`thumbnail_pdf_page_${pageNumber}`}
            data-window-key={pageNumber}
            className={`thumbnail-page ${currentPage === pageNumber ? "page-selected" : ""}`}
            style={{ marginTop: "10px" }}
            ref={currentPage === pageNumber ? thumbnailRef : null}
            onClick={() => onThumbnailClick(pageNumber, setPageNumber)}
          >
            {visiblePages.has(pageNumber) && (
              <Page
                scale={THUMBNAIL_SCALE}
                pageNumber={pageNumber}
                renderTextLayer={false}
                renderAnnotationLayer={false}
              />
            )}
          </div>
        );
      })}
    </>
  );
};

export default PdfThumbnailRail;
